import { get } from '@indeed/ifl-css';

const disabledStyles = _ref => {
  let {
    disabled = false
  } = _ref;
  return disabled ? {
    opacity: 0.4,
    pointerEvents: "none",
    userSelect: "none"
  } : {};
};

// used by InputWrapper for Input and TextArea
const inputFocusStyles = _ref2 => {
  let {
    invalid
  } = _ref2;
  const focusColor = invalid ? "border.status.critical.strong" : "utility.focus";
  const styles = {
    borderColor: focusColor,
    boxShadow: _ref3 => {
      let {
        colors
      } = _ref3;
      return `inset 0 -3px 0 0 ${get(colors, focusColor)}`;
    }
  };
  return {
    ":focus-within::before": {
      ...styles
    },
    "&.focus-within::before": {
      ...styles
    }
  };
};

// used by Select and Dropdown
const focusStyles = _ref4 => {
  let {
    invalid
  } = _ref4;
  const focusColor = invalid ? "border.status.critical.strong" : "utility.focus";
  const styles = {
    borderColor: focusColor,
    boxShadow: _ref5 => {
      let {
        colors
      } = _ref5;
      return `inset 0 -3px 0 0 ${get(colors, focusColor)}`;
    }
  };
  return {
    ":focus-within": {
      ...styles
    },
    "&.focus-within": {
      ...styles
    }
  };
};

export { disabledStyles, focusStyles, inputFocusStyles };
